// DEPLOYMENT_ENV is passed via .github/workflows/deploy.yml
const deploymentEnv = process.env.DEPLOYMENT_ENV ?? 'development';

// csm.maddox.ai serves a handful of internal users on the production data: trace everything there.
export const SENTRY_SAMPLING_RATE = deploymentEnv === 'production' ? 0.25 : deploymentEnv === 'csm' ? 1 : 0;
